import { Box, Group } from '@mantine/core';
import { InitiativeStatus } from '../../../../api/initiative-client/initiative-client.type';
import { toggleInitiativeStatusSelection } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { Checkbox } from '../../../../ui-library/checkbox/checkbox';
import { StatusLabel } from './status-label';

type Props = {
  status: InitiativeStatus;
  label: string;
  color: string;
  isSelected: boolean;
};

export const InitiativeStatusItem = ({ status, label, color, isSelected }: Props) => {
  const handleStatusToggle = () => {
    toggleInitiativeStatusSelection(status);
  };

  return (
    <Group gap="sm" wrap="nowrap" style={{ flex: 1 }}>
      <Checkbox checked={isSelected} onChange={handleStatusToggle} size="sm" />
      <Box
        style={{
          cursor: 'pointer',
          flex: 1,
        }}
        onClick={handleStatusToggle}
      >
        <StatusLabel color={color} label={label} />
      </Box>
    </Group>
  );
};
